<template>
  <section class="common-section">
    <v-container>
      <transition>
        <router-view></router-view>
      </transition>
    </v-container>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>